import { WindowLevelTool } from "@cornerstonejs/tools";
import React, { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { setVOILUTRange } from "../../../helpers/WindowLevelUtility";
import themeContext from "../../../../../context/theme/ThemeContext";


const parseWindowLevelPresetKey = (key) => {
  const m = key.match(/^(.+)\s\((\d+)\)$/);
  if (m) {
    return { displayName: m[1].trim(), shortcut: m[2] };
  }
  return { displayName: key, shortcut: null };
};

const WindowLevelPresets = ({ wl, setShowDropDown }) => {
  const [hovered, setHovered] = useState(false);
  const { activeViewportIndex, activeTool, isMPRActive } = useContext(ViewportContext);
const [activePreset, setActivePreset] = useState("");
const { theme } = useContext(themeContext);

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleWindowLevelPresetClick = () => {
    setShowDropDown(false);
    setActivePreset(wl.key);
    setVOILUTRange(activeViewportIndex, wl.ww, wl.wc, wl.edge, isMPRActive);
  };

  useEffect(() => {
    if(activeTool !== WindowLevelTool.toolName) {
        setActivePreset("");
    }
  }, [activeTool]);

  const { displayName, shortcut } = parseWindowLevelPresetKey(wl.key);

  return (
    <div
    //   style={{ display: "flex", alignItems :"center", height: "40px", color: `${hovered ? "#0085FF" : "white"}` }}
      className={`stack-scroll-dropdown-elements window-level-preset-row ${
        hovered ? "hovered":""}`}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      onClick={handleWindowLevelPresetClick}
    >
      <span className="viewer-toolbar-more-menu-label">{displayName}</span>
      {/* hide the keyboard-shortcut number on mobile — shortcuts don't
          work on touch devices, so showing "1..9" next to the CT presets is misleading. */}
      {shortcut && !isMobile ? (
        <span className="viewer-toolbar-more-menu-shortcut">{shortcut}</span>
      ) : null}
    </div>
  );
};

export default WindowLevelPresets;
